export const faqs = [
  {
    "id": "faq-audience",
    "question": "Who is this for?",
    "answer": "Team leaders, internal HR/L&D facilitators and small-business owners who run communication practice for 3-12 coworkers. Participants use the supplied role cards and observation sheets."
  },
  {
    "id": "faq-scope",
    "question": "What does the complete guide cover?",
    "answer": "Five workshops: Clear Requests; Listening and Checking Understanding; Useful Status Updates; Clear Work Handoffs; Clearing Up Everyday Misunderstandings. The $27 offer includes the complete guide and five bonus PDFs."
  },
  {
    "id": "faq-prep",
    "question": "What do I need to prepare?",
    "answer": "Read the facilitator plan and print or share the participant pages before the session. The cases, scripts, model dialogues and feedback criteria are already written. You do not need to invent a scenario."
  },
  {
    "id": "faq-cases",
    "question": "Why are there two cases per workshop?",
    "answer": "Case A is the default for the 30-minute session. Case B is an alternative or a later repeat. Run one case per session; both cases are not squeezed into the same 30 minutes."
  },
  {
    "id": "faq-format",
    "question": "What file types are included?",
    "answer": "English PDFs: the complete facilitator guide with printable participant materials and five bonus PDFs. No physical product, video, slide deck, editable templates, software or certification is included."
  },
  {
    "id": "faq-license",
    "question": "Can I use the materials with my team?",
    "answer": "Yes. Print or share participant pages with your own internal team. The license does not include resale, public redistribution or use as a product sold to external clients."
  },
  {
    "id": "faq-remote",
    "question": "Can we practice remotely?",
    "answer": "Yes. Share the role cards before the call, use small breakout groups where available, and return for debrief. The Facilitator Rescue Kit includes a fallback if audio or breakout rooms fail."
  },
  {
    "id": "faq-bonuses",
    "question": "What are the five bonuses?",
    "answer": "The 5-Week Team Communication Practice Calendar; 15 Five-Minute Communication Huddles; The Team Communication Needs & Skill Check Kit; The Workshop Invitation & Reminder Pack; The Team Communication Facilitator Rescue Kit. All five are included in the core price."
  },
  {
    "id": "faq-status",
    "question": "Is the store ready for purchase?",
    "answer": "Yes. The complete PDF guide and all five bonuses are included. Use the button in the offer section to complete your one-time purchase through the Impul checkout."
  },
  {
    "id": "faq-results",
    "question": "What does the kit help me do?",
    "answer": "It gives you prepared sessions and materials to run structured communication practice. Outcomes depend on your team and how the skills are used; there is no guaranteed performance result."
  }
];
